<template>
	<div class="request-answer" @click="handleLinkClick">
		<p v-for="(msg, index) in chatMessages"
			:key="index"
			:class="{request: msg.role === 'user', answer: msg.role === 'assistant'}"
			v-html="parseMarkdown(msg)"
		></p>
		<div v-show="writing && chatMessages?.length" class="writing-loading"><AppLoader :size="16"/>{{getString('generating_answer')}}</div>
		<div class="centered p-20" v-show="!chatMessages?.length"><AppLoader :size="36"/></div>
	</div>
</template>
<script>

import AppLoader from "@/shared/components/AppLoader.vue";
import {useLanguageStore} from "@/shared/stores";
import {formatDateMMDDHHmm} from "@/shared/helpers/dates";
import {useRouter} from "vue-router";

export default {
	setup() {
		let languageStore = useLanguageStore();
		const router = useRouter();
		return {getString: languageStore.getString, router}
	},
	components: {AppLoader},
	props: {
		writing: {
			type: Boolean,
			default: false
		},
		chatMessages: {
			type: Array,
			default: []
		}
	},
	methods: {
		parseMarkdown(msg) {
			const date = msg?.created_at;
			if(msg?.role === 'user') {
				let userContent = (msg?.request_data || "");
				// Add attachment indicator if message has attachments
				if(msg?.attachments && msg.attachments.length > 0) {
					const attachmentCount = msg.attachments.length;
					const attachmentLabel = attachmentCount === 1
						? this.getString('image_attached')
						: this.getString('images_attached');
					userContent += '<br><span class="attachment-indicator">' + attachmentCount + ' ' + attachmentLabel + '</span>';
				}
				return userContent + '<br><p class="date">'+formatDateMMDDHHmm(date)+'</p>';
			}
			let startingMessage = (msg?.response_data || '');
			return this.$sanitize(startingMessage.replace(/\*\*(.*?)\*\*/g, "<b>$1</b>")
				.replace(/_(.*?)_/g, "<i>$1</i>")
				.replace(/^#### (.*?)\s*#*$/gm, '<h4>$1</h4>')
				.replace(/^### (.*?)\s*#*$/gm, '<h3>$1</h3>')
				.replace(/^## (.*?)\s*#*$/gm, '<h2>$1</h2>')
				.replace(/^# (.*?)\s*#*$/gm, '<h1>$1</h1>')
				.replace(/\n/g, "<br />")
				.replace(/---/g, "<hr />")
				.replace(/【[^【】]*】/g, '')
				.replace(/\[([^\]]+)\]\(\/([^)]+)\)/g, '<a href="/$2" class="console-link" data-route="/$2">$1</a>'),
				{allowedTags: ['br', 'hr', 'b', 'i', 'h1', 'h2', 'h3', 'h4', 'a'], allowedAttributes: {'a': ['href', 'class', 'data-route']}})
				+'<br><p class="date">'+formatDateMMDDHHmm(date)+'</p>'
		},
		handleLinkClick(event) {
			if (event.target.classList.contains('console-link')) {
				event.preventDefault();
				const route = event.target.dataset.route;
				if (route) {
					this.router.push(route);
					this.$emit('link-clicked');
				}
			}
		},
	}
}
</script>

<style scoped lang="scss">
.request-answer {
	display: flex;
	flex-direction: column;
	gap: 20px;
	p {
		text-align: left;
		user-select: text;
		-webkit-user-select: text;
		-moz-user-select: text;
		-ms-user-select: text;
	}
	.request {
		background-color: var(--color-alpha-1);
		border-radius: 13px 13px 0 13px;
		padding: 10px 20px;
		max-width: 75%;
		margin-left: auto;
		margin-right: 0;
		transition: background-color 0.3s $transition;
	}
	.answer {
		:deep(h1) {
			line-height: 32px;
		}
		:deep(h2) {
			line-height: 24px;
		}
	}
	.request, .answer {
		:deep(p.date) {
			@include noSelect();
			text-align: right;
			font-size: 10px;
			line-height: 10px;
			margin-top: 2px;
			color: grey;
		}
		:deep(.attachment-indicator) {
			display: inline-block;
			font-size: 11px;
			color: var(--color-primary);
			opacity: 0.8;
			margin-top: 4px;
		}
	}
	.writing-loading {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 10px;
		color: var(--color-primary);
	}
}
</style>